import { Box, Button, List, ListItem, Stack, Typography } from "@mui/material";
import { DOCUMENTS } from "../utils/constants";
import { PRODUCT_WRAPPER, UPLOAD_FILE_NAME, UPLOAD_TITLE } from "./styles";
import RECORDS_ICON from "../assets/images/file.png";

const Help = () => {
  const handleDownload = async (url: string, _filename: string) => {
    window.open(url, "_blank");
  };
  return (
    <Box sx={PRODUCT_WRAPPER}>
      <Stack spacing={2}>
        <Typography sx={UPLOAD_TITLE}>Help Guide</Typography>
        {DOCUMENTS.length > 0 ? (
          <List sx={{ overflowY: "auto" }}>
            {DOCUMENTS.map((doc: any, index: number) => (
              <ListItem
                key={`document_${index}`}
                sx={{
                  border: "1px solid #F1F2F3",
                  borderRadius: "8px",
                  padding: "11px 16px",
                  marginBottom: 1,
                  flex: 1,
                }}
                secondaryAction={
                  <Button
                    variant="text"
                    sx={{ textTransform: "none" }}
                    onClick={() => {
                      handleDownload(doc?.url, doc?.name);
                    }}
                  >
                    View
                  </Button>
                }
              >
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flex={1}
                  spacing={2}
                >
                  <img src={RECORDS_ICON} alt={"file"} height={32} />
                  <Typography sx={{ ...UPLOAD_FILE_NAME, fontWeight: 500 }}>
                    {doc?.name || ""}
                  </Typography>
                </Stack>
              </ListItem>
            ))}
          </List>
        ) : (
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            marginTop={5}
          >
            <Typography>No files found!</Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default Help;
